export default __webpack_public_path__ + "static/media/problema-09.b5267e1d.webp";